module.exports = __webpack_public_path__ + "img/logo.27aa01b6.svg";